import { render, staticRenderFns } from "./WidgetConfigure.vue?vue&type=template&id=33af271f&scoped=true&"
import script from "./WidgetConfigure.vue?vue&type=script&lang=js&"
export * from "./WidgetConfigure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33af271f",
  null
  
)

export default component.exports